import PatientsTable from './PatientsTable';
import getPermission from 'lib/utils/getPermission';
import { TableContext } from '.';
import PatientsFilter from './PatientsFilter';
import { PatientFilters } from './PatientFilterTags';
import PatientsListFilterBar from './PatientsListFilterBar';

export default function PatientsListBody({
  filters,
  setFilters,
  patients,
  valueForTableContext,
  isFiltersOpen,
  resetFilters,
  activeFilterTypes,
  filterName,
  onFilterButtonClick,
  onSearch,
  openNewPatientDialog,
  openImportPaitentDialog,
}) {
  return (
    <TableContext.Provider value={valueForTableContext}>
      {/* Left column: Filters (only when open) */}
      {isFiltersOpen && (
        <PatientsFilter
          filters={filters}
          setFilters={setFilters}
          patients={patients}
          resetFilters={resetFilters}
          activeFilterTypes={activeFilterTypes}
        />
      )}
      
      {/* Right column: Filter bar + Patient content */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', minWidth: 0 }}>
        {/* Only show filter bar when we have the required props (main patients page) */}
        {onFilterButtonClick && onSearch && (
          <PatientsListFilterBar
            filterName={filterName}
            onFilterButtonClick={onFilterButtonClick}
            onSearch={onSearch}
            openNewPatientDialog={openNewPatientDialog}
            openImportPaitentDialog={openImportPaitentDialog}
          />
        )}
        
        {/* This function only present for patient groups */}
        {!valueForTableContext.handleDeletePatient && <PatientFilters />}
        
        <div style={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
          {getPermission('TRIAGE_DASHBOARD', 'read') && <PatientsTable />}
        </div>
      </div>
    </TableContext.Provider>
  );
}
